<div class="mt-5 ">
    <div class="row m-0">
        <div class="col">
            <div *ngIf="parks.length == 0" style="display: inline-flex;" class="mb-1">

                <li class="list-group-item d-flex justify-content-between align-items-center list-group-item-warning"
                    [style.width]="'100%'">
                    Lista vuota. Non hai parchi mezzi assegnati,
                    contatta un amministratore di sistema per amministrare dei parchi mezzi.
                </li>
            </div>
        </div>
    </div>
    <div class="row m-0">
        <div class="col">
            <accordion [closeOthers]="true">
                <accordion-group *ngFor="let park of parks" class="mt-2" [(isOpen)]="park.isOpen"
                    (isOpenChange)="openChanged(park)">
                    <div class="clearfix" accordion-heading>
                        <div class="pull-left float-left pt-2">{{ park.name }}</div>
                        <button class="btn btn-link float-right pull-right" [disabled]="!vehicles[park.id]">
                            <i class="fas fa-file-excel iconCustom"
                                (click)="exportService.exportAuto(vehicles[park.id])"></i>
                        </button>
                    </div>
                    <div class="row m-0">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon14">Cerca veicolo</span>
                            </div>
                            <input type="text" class="form-control" placeholder="Cerca..."
                                (input)="onVehicleChanged(plateInput.value)" #plateInput [ngModel]="searched_plate"
                                aria-label="cerca targa">
                        </div>
                        <ul class="list-group mb-3" style="width:100%;" #listGroup
                            [hidden]="vehicles_filtered.length == 0">
                            <li class="list-group-item" style="  font-size: 10px; padding: 10px;"
                                *ngFor="let vehicle of vehicles_filtered" [class.active]="selected_vehicle === vehicle"
                                (click)="vehicleSelected(vehicle)">
                                <div style="clear: both;">
                                    <div style="float: left;">
                                        <div>
                                            <b>{{vehicle.plate}}</b>
                                        </div>
                                        <div>
                                            {{vehicle.model.name}} {{vehicle.model.brand.name}}
                                        </div>
                                    </div>
                                    <div style="float: right;">
                                        <div>
                                            Chilometriaggio: <b>{{!!vehicle.max_kilometers ?
                                                vehicle.max_kilometers + ' Km' : '...'}}</b>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="row m-0" *ngIf="selected_vehicle">
                        <div class="col col-md-6">
                            <ul class="list-group mb-3" *ngIf="travels.length !== 0" style="width:100%;" #listGroup>
                                <div class="btn-group btn-group-justified" role="group" aria-label="...">
                                    <div class="btn-group" role="group">
                                        <button type="button" class="btn btn-default" [disabled]="to_hide_prev_tr"
                                            (click)="prevTravelPage()">
                                            << </button>
                                    </div>
                                    <div class="btn-group" role="group">
                                        <button type="button" class="btn btn-default" disabled>
                                            Viaggi {{ (5 * (travels_page - 1)) }} -
                                            {{(5 * (travels_page - 1) + travels.length) }}
                                        </button>
                                    </div>
                                    <div class="btn-group" role="group">
                                        <button type="button" class="btn btn-default" [disabled]="to_hide_next_tr"
                                            (click)="nextTravelPage()"> >> </button>
                                    </div>
                                </div>
                                <li class="list-group-item" style="font-size: 10px; padding: 10px; position: relative;"
                                    *ngFor="let travel of travels" [class.active]="selected_travel === travel"
                                    (click)="travelSelected(travel)">
                                    <div style="position:absolute; right: 0; top:0; width: 3%; height: 100%;"
                                        [class.list-group-item-success]='travel.status.id == 3 &&
                                         travel.travelEnded()' [class.list-group-item-pending]='travel.status.id == 3 &&
                                         !travel.travelEnded()' [class.list-group-item-danger]='travel.status.id == 2'
                                        [class.list-group-item-alert]='travel.status.id == 1 &&
                                         travel.travelRequested() &&
                                         !travel.travelApproved()'></div>
                                    <div style="position:absolute; right: 0; bottom:0; ">
                                        <button type="button" class="btn btn-warning btn-sm"
                                            (click)="editTravel(travel)">
                                            <span class="oi oi-pencil"></span>
                                        </button>
                                    </div>
                                    <div>
                                        {{dateHandler.formatDateClassic(travel.required_from)}} :
                                        {{dateHandler.formatTimeClassic(travel.required_from)}} -
                                        {{dateHandler.formatDateClassic(travel.required_to)}} :
                                        {{dateHandler.formatTimeClassic(travel.required_to)}}
                                    </div>
                                    <div>
                                        Guidatore: {{travel.user.name}} {{travel.user.surname}}
                                    </div>
                                    <div>
                                        Persone Trasportate: {{travel.passengers}}
                                    </div>
                                    <div>
                                        Motivazione: {{determineMotivationOther(travel)}}
                                    </div>
                                    <div>
                                        Km iniziali: <b>{{travel.start_kilometers}}</b> - Km finali: <b>
                                            {{travel.end_kilometers}}</b>
                                    </div>
                                </li>
                            </ul>
                            <em *ngIf="travels.length === 0">Nessun viaggio trovato su questo veicolo</em>
                        </div>
                        <div class="col col-md-6">
                            <ul class="list-group mb-3" *ngIf="refills.length !== 0" style="width:100%;" #listGroup>
                                <div class="btn-group btn-group-justified" role="group" aria-label="...">
                                    <div class="btn-group" role="group">
                                        <button type="button" class="btn btn-default" [disabled]="to_hide_prev_rf"
                                            (click)="prevRefillPage()">
                                            << </button>
                                    </div>
                                    <div class="btn-group" role="group">
                                        <button type="button" class="btn btn-default" disabled>Rifornimenti
                                            {{ (5 * (refills_page - 1)) }} -
                                            {{(5 * (refills_page - 1) +
                                            refills.length) }}</button>
                                    </div>
                                    <div class="btn-group" role="group">
                                        <button type="button" class="btn btn-default" [disabled]="to_hide_next_rf"
                                            (click)="nextRefillPage()"> >>
                                        </button>
                                    </div>
                                </div>
                                <li class="list-group-item" style="font-size: 10px; padding: 10px; position: relative;"
                                    *ngFor="let refill of refills" [class.active]="selected_refill === refill"
                                    (click)="refillSelected(refill)">
                                    <div style="position:absolute; right: 0; top:0; width: 3%; height: 100%;"
                                        [class.list-group-item-success]='refill.status.id == 3'
                                        [class.list-group-item-danger]='refill.status.id == 2'
                                        [class.list-group-item-pending]='refill.status.id == 1'></div>
                                    <div style="position:absolute; right: 0; bottom:0; ">
                                        <button type="button" class="btn btn-warning btn-sm"
                                            (click)="editRefill(refill)">
                                            <span class="oi oi-pencil"></span>
                                        </button>
                                    </div>
                                    <div>
                                        {{dateHandler.formatDateClassic(refill.made_at)}} :
                                        {{dateHandler.formatTimeClassic(refill.made_at)}}
                                    </div>
                                    <div>
                                        Chilometri: {{refill.kilometers}}
                                    </div>
                                    <div>
                                        Litri: {{refill.quantity}}
                                    </div>
                                    <div>
                                        Costo: {{refill.amount}} €
                                    </div>
                                </li>
                            </ul>
                            <em *ngIf="!selected_travel">Scegli un viaggio per vedere i rifornimenti</em>
                            <em *ngIf="selected_travel && refills.length === 0">Nessun rifornimento trovato</em>
                        </div>
                    </div>
                </accordion-group>
            </accordion>
        </div>
    </div>
    <app-change-km-travel></app-change-km-travel>
    <app-change-refills></app-change-refills>
</div>